import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ExpirationStatus } from '@amzn/handshake-painter-typescript-client/v1';
import errorKnockoutTokens from '@amzn/meridian-tokens/base/icon/error-knockout';
import Box from '@amzn/meridian/box';
import Column from '@amzn/meridian/column';
import Icon from '@amzn/meridian/icon';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import { useBundle } from '@amzn/react-arb-tools';
import { rio } from '@amzn/rio-design-tokens';
import styled from '@emotion/styled';
import React from 'react';
const PaymentCardImage = styled.img `
  width: 63px;
  height: 40px;
  border-radius: 4px !important;
`;
const PaymentMethodWrapper = styled.div `
  touch-action: manipulation;

  // Each box gets a top border, except for the last box which also gets a bottom border.
  border: 1px solid ${({ theme }) => rio.base.color.gray[theme.mode === 'dark' ? 300 : 1400]};

  &:not(:last-of-type) {
    border-bottom: none;
  }

  &:first-of-type {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  &:last-of-type {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  ${({ isSelected, theme }) => isSelected &&
    `
      background-color: ${rio.base.color.gray[theme.mode === 'dark' ? 300 : 1400]};
      box-shadow: 0 0 0 2px ${theme.rio.semantic.color.border.selected};
      position: relative;
  `}
`;
export const PaymentMethod = ({ paymentMethod, isSelected, onSelect }) => {
    var _a;
    const [bundle, isBundleLoading] = useBundle('pages.paymentSelectionPage');
    if (isBundleLoading)
        return null;
    const cardDisplayName = `${paymentMethod.cardBrand} ${paymentMethod.cardTypeTranslationKey ? bundle.getMessage(paymentMethod.cardTypeTranslationKey) : ''}`.trim();
    const cardExpiryDisplay = paymentMethod.cardExpirationStatus === ExpirationStatus.DoesNotExpire
        ? bundle.getMessage('noExpirationDate')
        : paymentMethod.cardExpirationDate;
    const cardInvalidDisplayMessage = (_a = paymentMethod.providedInvalidReason) !== null && _a !== void 0 ? _a : (paymentMethod.cardExpirationStatus === ExpirationStatus.IsExpired ? bundle.getMessage('expired') : '');
    return (_jsx(PaymentMethodWrapper, { isSelected: isSelected, onClick: paymentMethod.isInvalid ? undefined : onSelect, "data-payment-method-id": paymentMethod.paymentMethodId, "data-testid": "payment-method", "data-selected": isSelected, children: _jsx(Box, { spacingInset: "350", children: _jsxs(Row, { spacing: "300", alignmentVertical: "center", children: [_jsx(PaymentCardImage, { src: paymentMethod.cardImageUrl ||
                            'https://m.media-amazon.com/images/G/01/ShopExternal/images/payments/card._CB1198675309_.svg', alt: cardDisplayName }), _jsxs(Column, { spacing: "100", children: [_jsxs(Text, { type: "b200", children: [cardDisplayName, " \u2022\u2022\u2022\u2022", paymentMethod.tail] }), _jsx(Text, { type: "b200", color: "secondary", children: cardExpiryDisplay }), paymentMethod.isInvalid && (_jsxs(Row, { spacing: "300", alignmentVertical: "center", children: [_jsx(Icon, { tokens: errorKnockoutTokens, color: "error" }), _jsx(Text, { type: "b200", color: "error", children: cardInvalidDisplayMessage })] }))] })] }) }) }));
};
